import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTag,
  faUser,
  faPhone,
  faList,
  faBell,
  faInfoCircle,
  faHandshake,
  faTruck,
  faShieldAlt,
  faFileAlt,
  faLaptop,
  faPoll,
  faVoteYea,
  faBroadcastTower,
  faComments,
  faStar,
  faCashRegister,
  faHeadset,
} from "@fortawesome/free-solid-svg-icons";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const LeadGenerationServices = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-out",
      once: true,
    });
  }, []);

  const services = [
    { icon: faTag, title: "Coupon Delivery" },
    { icon: faUser, title: "User Registration" },
    { icon: faPhone, title: "Call Back Service" },
    { icon: faList, title: "Opt-in List Building" },
    { icon: faBell, title: "Alert Subscription" },
    { icon: faInfoCircle, title: "Information Pulling" },
    { icon: faHandshake, title: "Pledge Campaign" },
    { icon: faTruck, title: "Cash on Delivery Verification" },
    { icon: faShieldAlt, title: "Customer Mobile Verification Service" },
    { icon: faUser, title: "Web User Registration Verification" },
    { icon: faLaptop, title: "E-commerce Mobile Validation" },
    { icon: faPoll, title: "Opinion Poll Campaign" },
    { icon: faVoteYea, title: "Live Voting Event" },
    { icon: faBroadcastTower, title: "Live Event Feed" },
    { icon: faComments, title: "Consumer Survey" },
    { icon: faFileAlt, title: "Customer Feedback Report" },
    { icon: faStar, title: "Customer Rating Report" },
    { icon: faCashRegister, title: "Point of Sale Feedback" },
    { icon: faHeadset, title: "Chat Support Rating" },
  ];

  return (
    <div className="bg-gray-100 text-gray-800 py-16">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="md:text-3xl text-2xl font-bold text-center text-main1 mb-2">
          Where to use Lead Generation
        </h2>
        <div className="w-40 mx-auto border-b-4 border-main1 mb-8 rounded-full" />

        <div
          data-aos="fade-up"
          className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6"
        >
          {services.map((service, index) => (
            <div
              key={index}
              className="flex items-center space-x-4 border border-gray-200 bg-white p-4 rounded-xl shadow hover:shadow-lg transition duration-300"
            >
              <div className="flex items-center justify-center space-y-2 gap-2">
                <div className="bg-primary text-main1 w-14 h-14 flex items-center justify-center rounded-full shadow-md">
                  <FontAwesomeIcon icon={service.icon} className="text-xl" />
                </div>
                <p className="text-gray-800 text-base font-medium">
                  {service.title}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LeadGenerationServices;
